const styles = (theme) => ({
  dialog: {
    width: "75%",
    maxWidth: "75%",
    minHeight: "70%",
    height: "75%",
    maxHeight: "80%",
    backgroundColor: theme.ModalBGColor,
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
    borderBottom: `1px solid ${theme.scrollThumbColor}`,
  },
  closeContainer: {
    textAlignLast: "right"
  },
  closeButton: {
    color: theme.iconColor,
  },
  dialogTitleText: {
    fontSize: theme.headerTextFontSize,
    fontWeight: "600",
    lineHeight: "20px",
    color: theme.palette.primary.main,
    padding: 0,
    display: "flex",
    alignItems: "center",
  },
  dialogContent: {
    padding: "0 0 33 0",
    overflow: "hidden"
  },
  disableSection: {
    pointerEvents: "none",
    opacity:0.4,
  }
});
export default styles;
